import { REHYDRATE } from 'redux-persist/lib/constants';
import qs from 'qs';
import isEqual from 'lodash/isEqual';
import { getDefaultQuery, buildQuery, parseProductQueryString } from '../../utils/products.js';
import { storageAvailable } from '../../components/common/storageAvailable';
import { isMarketing } from '../../utils/pdp';

export default function request(state = {}, action={}) {
  const { type } = action;
  if (type === 'SET_REQUEST') {
    const { request={} } = action;
    return { ...state, ...request };
  }
  if (type === 'SET_RENDERING_INFO') {
    let { info = {} } = action;
    return { ...state, info };
  }
  if (type === REHYDRATE) {
    const { payload = {} } = action;
    const { request = {} } = payload;
    let { query: prevQuery = {} } = request;
    const { location = {} } = window;
    if (storageAvailable('localStorage')) {
      var storageRequest = localStorage.getItem('plpRequestMobile');
    }
    if (storageRequest) {
      try {
        storageRequest = JSON.parse(storageRequest);
      } catch (e) {}
    }
    storageRequest = storageRequest || {};
    const blackList = [
      'hash',
      'gridColumns',
      'viewType',
      'fields',
      'currentPage',
      'pageSize',
      'format',
      'facets'
    ];

    prevQuery = buildQuery(prevQuery, {
      defaultQuery: getDefaultQuery(),
      blackList
    });

    let locationQuery = qs.parse(location.href.split('?')[1] || '');
    if (locationQuery && (locationQuery.query || locationQuery.q)) {
      locationQuery.query = locationQuery.query || locationQuery.q;
    } else if (
      storageRequest.href &&
      storageRequest.href == location.href &&
      storageRequest.request &&
      storageRequest.request.query
    ) {
      locationQuery = storageRequest.request.query;
    }

    let currQuery = buildQuery(locationQuery, {
      defaultQuery: getDefaultQuery(),
      blackList
    });

    currQuery = {
      ...currQuery,
      ...parseProductQueryString(currQuery.query || '')
    };

    prevQuery = {
      ...prevQuery,
      ...parseProductQueryString(prevQuery.query || '')
    };

    const { pathname: locPathName = '', search = '' } = location;
    const { browserPath: reqPathName = '' } = request;
    const locPathSplits = locPathName.split('/');
    const reqPathSplits = reqPathName.split('/');

    if (locPathSplits.indexOf('p') !== -1) {
      return request.deviceType == 'mobile' ? { ...request } : { ...state };
    }
    if (['cp', 'capsule', 'wishlist', 'cart'].includes(locPathSplits[1])) {
      return { ...state };
    }
    if (
      location.pathname == request.browserPath &&
      ((request &&
        request.deviceType === 'mobile' &&
        ['search', 's'].includes(locPathSplits[1]) &&
        currQuery.text == prevQuery.text) ||
        isEqual(currQuery, prevQuery)) &&
      state.deviceType === request.deviceType
    ) {
      return { ...request };
    }
    if (
      locPathSplits[1] != reqPathSplits[1] &&
      ![
        'search',
        'c',
        'b',
        's',
        's1',
        'find',
        'cp',
        'capsule',
        'wishlist',
        'cart',
        'sizeguide-v2'
      ].includes(locPathSplits[1]) &&
      !['c'].includes(locPathSplits[2]) &&
      state.deviceType === request.deviceType
    ) {
      return { ...request };
    }

    return { ...state };
  }
  if (type === 'SET_DEVICETYPE') {
    const { deviceType = '' } = action;
    return { ...state, deviceType };
  }
  return state;
}
